import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
export default {
  props: ["user"],
  data: function data() {
    return {};
  },
  computed: {
    noticeContent: function noticeContent() {
      // 品牌充值 || 品牌季度
      if (this.user.user_type == 1 || this.user.user_type == 3) {
        return "Hello ".concat(this.user.name, ", Wellcee \u623F\u6E90\u4FE1\u606F\u4E0D\u63A5\u53D7\u5E26\u6709\u8054\u7CFB\u65B9\u5F0F\uFF0C\u8BF7\u77E5\u6089\u3002\u5982\u679C\u591A\u6B21\u6DFB\u52A0\u8054\u7CFB\u65B9\u5F0F\uFF0C\u623F\u6E90\u5C55\u793A\u6743\u91CD\u5C06\u88AB\u964D\u7EA7\uFF01");
      }
      if (this.user.lang == 1) {
        return "Hello ".concat(this.user.name, ", \u4F60\u7684\u623F\u6E90\u4FE1\u606F\u5DF2\u7ECF\u6210\u529F\u4E0A\u7EBF\u5566\uFF01 \u4E3A\u907F\u514D\u4E2D\u4ECB\u9A9A\u6270\u548C\u8BC8\u9A97\u98CE\u9669\uFF0CWellcee \u5C06\u5C4F\u853D\u623F\u6E90\u4FE1\u606F\u81EA\u5E26\u7684\u8054\u7CFB\u65B9\u5F0F. \u4E3A\u4E86\u60A8\u7684\u5B89\u5168\uFF0C\u5EFA\u8BAE\u60A8\u4E0D\u8981\u8DF3\u51FA\u5E73\u53F0\u6C9F\u901A\uFF08\u8BF7\u8BB0\u5F97\u6253\u5F00APP\u65B0\u6D88\u606F\u63A8\u9001\u5662\uFF09");
      } else if (this.user.lang == 2) {
        return "Hello ".concat(this.user.name, ", Your house listing is now online! To keep you safe from scams and unwanted calls, Wellcee will hide any contact details in your listing. For your own security, we recommend sticking to our platform for communication. PS: Don't forget to turn on notifications for Wellcee app :)");
      } else if (this.user.lang == 3) {
        return "Hello ".concat(this.user.name, ", \u4F60\u7684\u623F\u6E90\u4FE1\u606F\u5DF2\u7D93\u6210\u529F\u4E0A\u7DDA\u5566\uFF01\u70BA\u907F\u514D\u4E2D\u4ECB\u9A37\u64FE\u548C\u8A50\u9A19\u98A8\u96AA\uFF0CWellcee\u5C07\u5C4F\u853D\u623F\u6E90\u4FE1\u606F\u81EA\u5E36\u7684\u806F\u7E6B\u65B9\u5F0F\u3002\u70BA\u4E86\u60A8\u7684\u5B89\u5168\uFF0C\u5EFA\u8B70\u60A8\u4E0D\u8981\u8DF3\u51FA\u5E73\u53F0\u6E9D\u901A\uFF08\u8ACB\u8A18\u5F97\u6253\u958BAPP\u65B0\u6D88\u606F\u63A8\u9001\u5594\uFF09");
      } else {
        return "Hello ".concat(this.user.name, ", \u4F60\u7684\u623F\u6E90\u4FE1\u606F\u5DF2\u7ECF\u6210\u529F\u4E0A\u7EBF\u5566\uFF01 \u4E3A\u907F\u514D\u4E2D\u4ECB\u9A9A\u6270\u548C\u8BC8\u9A97\u98CE\u9669\uFF0CWellcee \u5C06\u5C4F\u853D\u623F\u6E90\u4FE1\u606F\u81EA\u5E26\u7684\u8054\u7CFB\u65B9\u5F0F. \u4E3A\u4E86\u60A8\u7684\u5B89\u5168\uFF0C\u5EFA\u8BAE\u60A8\u4E0D\u8981\u8DF3\u51FA\u5E73\u53F0\u6C9F\u901A\uFF08\u8BF7\u8BB0\u5F97\u6253\u5F00APP\u65B0\u6D88\u606F\u63A8\u9001\u5662\uFF09");
      }
    }
  },
  methods: {
    sendHouseNotice: function sendHouseNotice() {
      var _this = this;
      this.$confirm(this.noticeContent, "发送通知确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              // 操作上报
              _this.$operationLog.push({
                operationType: "house",
                code: _this.user.user_type > 0 ? "warn" : "notify",
                houseId: _this.$route.query.id,
                userId: _this.$route.query.userId
              });
              _context.n = 1;
              return _this.$api.sendHouseNotice({
                userId: _this.$route.query.userId
              });
            case 1:
              _this.$message.success("操作成功");
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))).catch(function () {});
    }
  }
};